/**
 * Runtime Surface Availability
 *
 * Controls which surfaces are currently enabled in the application.
 * Surfaces not in the enabled set are hidden from navigation and
 * their routes redirect to /not-found.
 *
 * This is SEPARATE from authorization (useCurrentUser/permissions).
 * A surface may be authorized for a user but disabled here because
 * the backend implementation doesn't exist yet.
 */

import type { SurfaceId } from "./schema"

const ENABLED_SURFACES: ReadonlySet<SurfaceId> = new Set([
  // Infrastructure
  "sign_in",
  "not_authorized",
  "not_found",
  "settings",

  // Entity lists — real backend (GET /api/<entity>, governed)
  "companies_list",
  "up_list",
  // companies_insights: DISABLED — no backend insights endpoint
  // company_dashboard: DISABLED — no backend metrics endpoint

  // Admin Master Lists — uses existing entity list APIs (admin sees all statuses)
  "admin_master_companies",
  "admin_master_people",
  "admin_master_investors",

  // admin_users: DISABLED — user management APIs not authorized (Doc 04 §1.3)
])

export function isSurfaceEnabled(id: SurfaceId): boolean {
  return ENABLED_SURFACES.has(id)
}
